import { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import api from "../../api.js";

const MySubjects = () => {
  const [subjects, setSubjects] = useState([]);
  const token = Cookies.get("access_token");

  useEffect(() => {
    api.get("/subject/me/", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((res) => {
      setSubjects(res.data);
    }).catch((err) => {
      console.error("Error fetching subjects", err);
    });
  }, []);

  return (
    <div className="container">
      {subjects.length === 0 ? (
        <p>هیچ موضوعی ثبت نشده است.</p>
      ) : (
        <div className="row">
          {subjects.map((subject) => (
                      <div className="col-12 col-md-6 col-lg-4 mb-4" key={subject.id}>
                        <Link to={`/subject/${subject.id}`} className="text-decoration-none text-dark">
                          <div className="card h-100 shadow-sm hover-shadow">
                            <div className="card-body">
                              <h5 className="card-title">{subject.title}</h5>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ))}
        </div>
      )}
    </div>
  );
};

export default MySubjects;
